export const slickSliderSettings = {
    speed: 500,
    centerMode: false,
    infinite: false,
    outerEdgeLimit: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        },
        {
            breakpoint: 650,
            settings: {
                variableWidth: true,
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: false
            }
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 1400,
            settings: {
                arrows: true
            }
        }
    ]
};
export const slickSliderSettings = {
    speed: 500,
    centerMode: false,
    infinite: false,
    outerEdgeLimit: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 440,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        },
        {
            breakpoint: 650,
            settings: {
                variableWidth: true,
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: false
            }
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 1400,
            settings: {
                arrows: true
            }
        }
    ]
};
